import { FaMinus, FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
import { checkFinalPrice } from "./checkFinalPrice";
import { toast } from "react-toastify";

const AddonCounter = ({ quantity, price = 0, onChange, darkMode }) => {
  const { color } = useSelector((state) => state.global);
  const { cartItems } = useSelector((state) => state.cart);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);

  
  const simulatedFinal = checkFinalPrice({
      cartItems: cartItems,
      restaurant: restaurantsDetail,
      itemPrice: price,
  });
  
  const isDisabled = simulatedFinal > 10000;

  const handleIncrement = () => {
    if(isDisabled) {
      return;
    }
    
    const simulatedFinal = checkFinalPrice({
      cartItems: cartItems,
      restaurant: restaurantsDetail,
      itemPrice: price * 2
    });

    if (simulatedFinal > 10000) {
      toast.warning("Total amount limit per order is 10,000.");
    }

    onChange(quantity + 1);
  };
  return (
    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
      {/* Minus Button */}
      <div
        style={{
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          border: `1px solid ${darkMode ? "#aaa" : "#888"}`,
          backgroundColor: "transparent",
          color: darkMode ? "#aaa" : "#666",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          cursor: "pointer",
        }}
        onClick={() => onChange(Math.max(0, quantity - 1))}
      >
        <FaMinus />
      </div>

      {/* Quantity Box */}
      <div
        style={{
          minWidth: "30px",
          height: "26px",
          borderRadius: "6px",
          border: `1px solid ${darkMode ? "#ffffff33" : "#ccc"}`,
          backgroundColor: "transparent",
          color: darkMode ? "#fff" : "#333",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        {quantity}
      </div>

      {/* Plus Button */}
      <div
        style={{
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          backgroundColor: "transparent",
           border: `1px solid ${isDisabled ? "rgb(170, 170, 172)" : color}`,
          color: color,
          pointerEvents: isDisabled ? "none" : "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          cursor: "pointer",
        }}
        onClick={handleIncrement}
      >
        <FaPlus 
            style={{
            color: isDisabled ? "rgb(170, 170, 172)" : color,
          }}
        />
      </div>
    </div>
  );
};

export default AddonCounter;
